import * as moment from 'moment';
import {cancelSplit, saveNewSplit} from './visavial';
import * as d3 from '../../vendors/d3/d3.min.js';


export function time_convert(num) {
  const hours = Math.floor(num / 60);
  const minutes = num % 60;
  return {hh: hours, mm: minutes};
}

let currentBlocks = null;
let blockTempsComponent = null;
let optionData = null;

const listener = function (ev: any) {
  if (ev.target.id == 'save' && blockTempsComponent && currentBlocks && optionData) {
    saveNewSplit(blockTempsComponent, currentBlocks);
    console.log('save !!', currentBlocks);
  }
  if (ev.target.id == 'cancel' && blockTempsComponent && currentBlocks && optionData) {
    console.log('cancel !!', currentBlocks);
    blockTempsComponent.GoToDate('refresh', currentBlocks.userName);
    d3.select('body .tooltip-split').remove();
  }
};
document.body.addEventListener('click', listener);
document.addEventListener('change', function (ev: any) {
  if (ev.target.id == 'selectMotifsplit') {
    const selected = BLOCKS_EVENT.MOTIFS.find(m => m.code == ev.target.value);
    if (selected) {
      currentBlocks.block['newMotif'] = selected;
    }
  }
});
export const BLOCKS_EVENT = {
  isActive: true,
  enableDrag: false,
  MOTIFS: [],
  modalTarget: null,
  // init get args, class blocksTemps
  init: function (args) {
    blockTempsComponent = args[1];
    optionData = args[0];
    const e = document.querySelector('.split-modal-overlay-container');
    if (!e) {
      const svg = document.createElement('SVG');
      const path = document.createElement('PATH');
      svg.classList.add('split-modal-overlay-container');
      svg.appendChild(path);
      document.body.appendChild(svg);
      BLOCKS_EVENT.modalTarget = svg;
    } else if(BLOCKS_EVENT.modalTarget) {
      const p = BLOCKS_EVENT.modalTarget;
      p.querySelector('path').style.d = '';
      p.classList.remove('split-modal-is-visible');
    }
  },
  diffDates: function (d1, d2) {
    if(!d1 || !d2) return 0;
    const difference = d2.getTime() - d1.getTime();
    const resultInMinutes = Math.round(difference / 60000);
    return resultInMinutes;
  },
  xScale: (d) => d,
  patch: function (d, libs) {
    const {xScale} = libs;
    BLOCKS_EVENT.xScale = xScale;
    const resultInMinutes = BLOCKS_EVENT.diffDates(d[0], d[2]);
    this.data = {
      date_: d, // interval update dates
      date: [d[0], d[2]], // interval dates
      duration: resultInMinutes, // durration default
      maxWidth: (xScale(d[2]) - xScale(d[0])), // calc width of durration
      blocks: []
    };
    Object.defineProperty(this, 'data', {configurable: false, writable: false});
    Object.defineProperty(this.data, 'date_', {configurable: false, writable: false});
    Object.defineProperty(this.data, 'date', {configurable: false, writable: false});
    Object.defineProperty(this.data, 'duration', {configurable: false, writable: false});
    Object.defineProperty(this.data, 'maxWidth', {configurable: false, writable: false});
  },
  drag: function (c, libs) {
    const {div, tooltip, parseDate, originData, optionData, openDialogJustifyIncoBreaks, event} = libs;
    if(!BLOCKS_EVENT.isActive) return;
    // hide tooltip info
    BLOCKS_EVENT.enableDrag = true;
    if (String(this.className.baseVal).includes('INCOHERENCE') ||
      String(this.className.baseVal).includes('inservice')) {
      const id = this.getAttribute('username');
      let motif = '';
      let label = '';
      let block = null;
      originData[id].data.forEach((t, i) => {
        if (t.tag.toLowerCase() === 'incoherence') {
          const same = typeof t.GMT === 'undefined' ?
            moment(t.start, 'YYYY-MM-DD HH:mm:ss')
              .isSame(moment(c[0], 'YYYY-MM-DD HH:mm:ss')) :
            moment(t.start, 'YYYY-MM-DD HH:mm:ss')
              .isSame(moment(c[0], 'YYYY-MM-DD HH:mm:ss'));

          if (same &&
            t.legend === c[1]
          ) {
            block = t;
            motif = (t.motif.label === '' ? '' : ' : ' + t.motif.label);
            label = (t.motif.label === '' ? 'En Production' : label);
            label = (label == 'En Production' ? label : optionData.legend[c[1]].label);
          }
        }
      });
      // disabled animation
      this.style.transition = 'all .0s';
      this.style.strokeWidth = 1;
      this.style.cursor = 'col-resize';
      Array.from(document.querySelectorAll('.tooltip') || []).forEach((e: any) => e.setAttribute('style', 'opacity: 0'));
      d3.select(this).attr('width', function (c) {
        const elementRect = this.getBoundingClientRect();

        const max = this.data.maxWidth;
        const duration = this.data.duration;
        const data = this.data;
        let calc = (d3.event.x - this.attributes.x.value);
        const t = new Date(c[0]);
        let r;
        // condition durration block has 10min open popup
        // console.log('[MAX] : [OPEN] = ', max, max <= 10);
        if(calc > max) {
          calc = max;
        }

        if ((max <= 10 || calc <= 10)) {
          BLOCKS_EVENT.enableDrag = false;
          d3.select('body .tooltip-split').remove();
          openDialogJustifyIncoBreaks.call(this, c);
          return max;
        } else {

          if (!(calc >= max || calc < 10)) {
            r = Math.round((calc * duration) / max);
          } else {
            r = Math.round((max * duration) / max);
          }


          const time = time_convert(r);
          t.setHours(t.getHours() + time.hh);
          t.setMinutes(t.getMinutes() + time.mm);
          // console.log('[MAX] : [OPEN] = ', t)

          c[2] = t.getTime() > this.data.date[1] ? this.data.date[1] : t;
          d3.select('.tooltip-split:not(:last-child)').remove();

          var d = c;
          var matrix = this.getScreenCTM().translate(+this.getAttribute('x'), +this.getAttribute('y'));
          div.style('opacity', 1);
          if (BLOCKS_EVENT.modalTarget && !BLOCKS_EVENT.modalTarget.classList.contains('split-modal-is-visible')) {
            BLOCKS_EVENT.modalTarget.classList.add('split-modal-is-visible');
            const {top, left, width, height} = elementRect;
            const d = BLOCKS_EVENT.pathBox(screen.width, screen.height, top, left, width, height);
            BLOCKS_EVENT.modalTarget.querySelector('path').style.d = d;
          }

          /*          div.html(function () {
                      let direction: any = '';
                      if (parseInt(elementRect.x) > (window.innerWidth - 300)) {
                        direction = 'style="right: -' + parseInt(elementRect.width) + 'px"';
                      } else {
                        direction = '';
                      }
                      const o = {
                        event,
                        direction: direction,
                        klass: 'ka',
                        justif: 'ju',
                        motif: motif,
                        label: label,
                        block,
                        data: data,
                        userName: id
                      };
                      currentBlocks = o;
                      return tooltip(o, d);
                    })
                      .style('left', function () {
                        return window.pageXOffset + matrix.e + 'px';
                      })
                      .style('top', function () {
                        return window.pageYOffset + matrix.f - 11 + 'px';
                      })
                      .style('height', this.dataHeight + 11 + 'px')*/
          ;

          return calc >= max || calc < 10 ? max : calc;
        }

      });
    }
  },
  on: {
    onResize:(libs) => {}
  },
  dragend: function (libs) {
    const {date, tooltip} = libs;
    // enable animation
    this.style.transition = 'all .4s';
    //this.style.strokeWidth = '8px';
    // this.style.cursor = 'default';
    if(BLOCKS_EVENT.on.onResize) BLOCKS_EVENT.on.onResize(libs);
  },
  pathBox: function (fullWidth, fullHeight, top, left, width, height) {
    return `path("
					M 0, ${fullHeight}  H 0
					V 0 H ${fullWidth}
					V ${fullHeight} Z M ${left} ${top} a 0 0 0 0 0 0 0
					V ${height + top} a 0 0 0 0 0 0 0 H ${width + left} a 0 0 0 0 0 0 0
					V ${top} a 0 0 0 0 0 0 0 Z
					")`.replace(/\n\t/gm, '');
  }
};

interface NewBlockVO {
  start: string;
  end: string;
  id: number;
  motif: {
    code: string;
    type: string;
  },
  type: string;
  uid: number;
  updated: boolean;
  tag: string;
}



// WEBPACK FOOTER //
// ./src/app/vendors/visavail/ResizeSplitBlock.ts